export default {
  list: {
    method: "post",
    url: `/api/policies/dashboard/my/policy`,
  },
  insurer: {
    method: "get",
    url: `/api/policies/dashboard/my/policy/list/insurer`,
  },
  detail: {
    method: "get",
    url: "/api/flight/v2/policies/:number",
  },
  products: {
    method: "get",
    url: "",
  },
  productCategories: {
    method: "get",
    url: "",
  },
  export: {
    method: "post",
    url: `/api/policies/dashboard/my/policy/reports`,
  },
  generateS3PresignUrl: {
    method: "post",
    url: "/api/flight/v2/documents",
  },
};
